import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';


interface MenuIcons {
    [key: string]: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
};
  
const menuIcons: MenuIcons = {
    "Contabilidad": () => <AccountBalanceIcon style={{color: "#FFFFFF", width: "1.125rem", height: "1.125rem",}} />,
    "Libro Diario": () => <MenuBookIcon style={{color: "#FFFFFF", width: "1.125rem", height: "1.125rem",}} />,
    "Sincronizar Libro Diario": () => <CloudUploadIcon style={{color: "#FFFFFF", width: "1.125rem", height: "1.125rem",}} />,
    
    
}

export default menuIcons